import { Link } from "react-router-dom";
import React from "react";
import "../styles/CyberSecurity.css";
import cyber1 from "../assets/services/CYBER 1.jpeg";
import cyber2 from "../assets/services/CYBER 2.jpeg";

const solutions = [
  {
    title: "Security Assessment",
    description:
      "Identify security gaps, vulnerabilities and risks across your digital environment with a structured security assessment.",
  },
  {
    title: "Network Security",
    description:
      "Protect networks and connected systems with security practices designed to reduce unauthorized access and potential threats.",
  },
  {
    title: "Endpoint Protection",
    description:
      "Secure computers, devices and endpoints with protection strategies that help keep business systems safer.",
  },
  {
    title: "Data Protection",
    description:
      "Protect sensitive business information through secure data handling, access controls and practical security measures.",
  },
  {
    title: "Monitoring & Response",
    description:
      "Monitor important systems and respond to potential security issues with structured processes and timely action.",
  },
  {
    title: "Security Awareness",
    description:
      "Help teams understand common digital threats and develop safer everyday practices through practical security awareness.",
  },
];

const process = [
  {
    title: "Identify",
    description:
      "Understand your systems, data and potential security risks before creating a protection strategy.",
  },
  {
    title: "Protect",
    description:
      "Implement practical security measures designed around your infrastructure, applications and business requirements.",
  },
  {
    title: "Monitor",
    description:
      "Keep an eye on important systems and activities to identify unusual behavior and potential security concerns.",
  },
  {
    title: "Respond",
    description:
      "Create clear response processes so security issues can be handled quickly and systematically.",
  },
];

function CyberSecurity() {
  return (
    <main className="cyber-page">

      {/* HERO */}
      <section className="cyber-hero">

        <div className="cyber-hero-content">

          <span className="cyber-eyebrow">
            CYBER SECURITY
          </span>

          <h1>
            Protect What
            <span> Matters Most</span>
          </h1>

          <p>
            Build stronger digital protection for your systems,
            applications, devices and business data with practical
            cybersecurity solutions.
          </p>

          <a
            href="#cyber-solutions"
            className="cyber-primary-btn"
          >
            Explore Security Solutions
            <span>→</span>
          </a>

        </div>

        <div className="cyber-hero-visual">

          <div className="cyber-hero-image">

            <img
              src={cyber1}
              alt="Cyber security technology"
            />

          </div>

        </div>

      </section>


      {/* INTRO */}
      <section className="cyber-intro">

        <div className="cyber-intro-header">

          <div className="cyber-intro-label">

            <span>01</span>

            <p>
              WHAT WE PROTECT
            </p>

          </div>

          <div className="cyber-intro-heading">

            <h2>
              Security designed around
              <span> your digital world</span>
            </h2>

            <p>
              From networks and endpoints to applications and
              business data, we help create practical security
              strategies that support safer digital operations.
            </p>

          </div>

        </div>


        <div className="cyber-intro-content">

          <div className="cyber-intro-main">

            <span>
              OUR APPROACH
            </span>

            <h3>
              Good security starts with
              <strong> understanding the risks</strong>
            </h3>

            <p>
              We focus on identifying potential weaknesses,
              strengthening protection and creating practical
              processes that help businesses respond to digital
              security challenges.
            </p>

          </div>


          <div className="cyber-intro-points">

            <div className="cyber-intro-point">

              <span>01</span>

              <div>

                <h4>
                  Proactive protection
                </h4>

                <p>
                  Identify potential risks early and strengthen
                  systems before they become larger problems.
                </p>

              </div>

            </div>


            <div className="cyber-intro-point">

              <span>02</span>

              <div>

                <h4>
                  Secure operations
                </h4>

                <p>
                  Build security practices into everyday business
                  operations, applications and workflows.
                </p>

              </div>

            </div>


            <div className="cyber-intro-point">

              <span>03</span>

              <div>

                <h4>
                  Faster response
                </h4>

                <p>
                  Create clear processes for identifying and
                  responding to security concerns.
                </p>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* SOLUTIONS */}
      <section
        className="cyber-solutions"
        id="cyber-solutions"
      >

        <div className="cyber-section-heading">

          <div>

            <span className="cyber-small-label">
              SECURITY SERVICES
            </span>

            <h2>
              Explore our
              <span> security solutions</span>
            </h2>

          </div>

          <p>
            Practical cybersecurity services designed to protect
            your digital environment and support safer operations.
          </p>

        </div>


        <div className="cyber-solutions-grid">

          {solutions.map((item) => (

            <article
              className="cyber-solution-card"
              key={item.title}
            >

              <div className="cyber-card-content">

                <h3>
                  {item.title}
                </h3>

                <p>
                  {item.description}
                </p>

              </div>

            </article>

          ))}

        </div>

      </section>


      {/* SECURITY SECTION */}
      <section className="cyber-tech-section">

        <div className="cyber-tech-content">

          <span className="cyber-small-label">
            DIGITAL PROTECTION
          </span>

          <h2>
            Security that works
            <span> behind the scenes</span>
          </h2>

          <p>
            Strong cybersecurity should support your business
            without making everyday work unnecessarily difficult.
            We focus on practical protection that fits into your
            existing digital environment.
          </p>


          <div className="cyber-tech-points">

            <div>

              <strong>01</strong>

              <h4>
                Protected systems
              </h4>

              <p>
                Strengthen devices, networks and applications
                against common security risks.
              </p>

            </div>


            <div>

              <strong>02</strong>

              <h4>
                Safer information
              </h4>

              <p>
                Protect important business and customer data
                with better security practices.
              </p>

            </div>


            <div>

              <strong>03</strong>

              <h4>
                Continuous awareness
              </h4>

              <p>
                Help teams understand digital threats and
                practice safer everyday working habits.
              </p>

            </div>

          </div>

        </div>


        <div className="cyber-tech-visual">

          <div className="cyber-tech-image">

            <img
              src={cyber2}
              alt="Cyber security technology"
            />

          </div>

        </div>

      </section>


      {/* PROCESS */}
      <section className="cyber-process">

        <div className="cyber-process-heading">

          <span className="cyber-small-label">
            HOW WE WORK
          </span>

          <h2>
            A structured approach to
            <span> digital security</span>
          </h2>

          <p>
            We follow a clear process to understand risks,
            strengthen protection and prepare your organization
            to respond to security concerns.
          </p>

        </div>


        <div className="cyber-process-grid">

          {process.map((item, index) => (

            <article
              className="cyber-process-item"
              key={item.title}
            >

              <div className="cyber-process-number">
                {String(index + 1).padStart(2, "0")}
              </div>

              <h3>
                {item.title}
              </h3>

              <p>
                {item.description}
              </p>

            </article>

          ))}

        </div>

      </section>


      {/* FINAL CTA */}
      <section className="cyber-final">

        <div className="cyber-final-content">

          <div className="cyber-final-main">

            <div className="cyber-final-label">

              <span></span>

              PROTECT YOUR DIGITAL FUTURE

            </div>

            <h2>
              Make security part
              <span> of your strategy</span>
            </h2>

            <p>
              Tell us about your systems, applications or
              security requirements. We can help you identify
              practical ways to strengthen your digital protection.
            </p>

          </div>


          <div className="cyber-final-action">

            <div className="cyber-final-brand">

              <strong>
                TECHLYNX INNOVATIONS
              </strong>

              <p>
                Security · Technology · Trust
              </p>

            </div>


            <Link
              to="/contact"
              className="cyber-final-btn"
            >
              Start a conversation
              <span>↗</span>
            </Link>

          </div>

        </div>

      </section>

    </main>
  );
}

export default CyberSecurity;